<template>
  <router-view />
</template>

<style>
:root {
  --oj-bg: #f4f7fb;
  --oj-panel: #ffffff;
  --oj-panel-soft: #f8fbff;
  --oj-border: #e5eaf3;
  --oj-border-strong: #d7e2f2;
  --oj-text: #17233d;
  --oj-muted: #64748b;
  --oj-primary: #1677ff;
  --oj-primary-soft: #e8f1ff;
  --oj-success: #22c55e;
  --oj-warning: #f59e0b;
  --oj-danger: #ef4444;
  --oj-radius: 10px;
  --oj-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  color: var(--oj-text);
  background: var(--oj-bg);
  font-family: Inter, ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.arco-card {
  color: var(--oj-text);
  background: var(--oj-panel);
  border: 1px solid var(--oj-border);
  border-radius: var(--oj-radius);
  box-shadow: var(--oj-shadow);
}

.arco-card-header {
  border-bottom-color: var(--oj-border);
}

.arco-card-header-title,
.arco-form-item-label,
.arco-descriptions-title,
.arco-table-th,
.arco-statistic-title {
  color: var(--oj-muted);
}

.arco-statistic-value,
.arco-descriptions-item-value,
.arco-table-td,
.arco-list-item {
  color: var(--oj-text);
}

.arco-table,
.arco-table-container,
.arco-table-tr,
.arco-table-th,
.arco-table-td {
  background: transparent !important;
  border-color: var(--oj-border) !important;
}

.arco-table-th {
  background: #f8fafc !important;
  font-weight: 600;
}

.arco-table-tr:hover .arco-table-td {
  background: #f8fbff !important;
}

.arco-input-wrapper,
.arco-select-view,
.arco-textarea-wrapper {
  color: var(--oj-text);
  background: #fff;
  border-color: var(--oj-border-strong);
  border-radius: 6px;
}

.arco-input,
.arco-textarea {
  color: var(--oj-text);
}

.arco-input::placeholder,
.arco-textarea::placeholder {
  color: #94a3b8;
}

.arco-btn {
  border-radius: 6px;
  font-weight: 500;
}

.arco-btn-primary {
  background: var(--oj-primary);
  border-color: var(--oj-primary);
  box-shadow: 0 6px 14px rgba(22, 119, 255, 0.18);
}

.arco-btn-primary:hover {
  background: #0f6bea;
  border-color: #0f6bea;
}

.arco-btn-text {
  color: var(--oj-primary);
}

.arco-link {
  color: var(--oj-primary);
}

.arco-tag {
  border-radius: 5px;
  font-weight: 500;
}

.arco-pagination-item,
.arco-pagination-jumper-input,
.arco-pagination-options-size-changer {
  color: var(--oj-text);
  background: #fff;
  border-color: var(--oj-border);
}

.arco-pagination-item-active {
  color: #fff;
  background: var(--oj-primary);
  border-color: var(--oj-primary);
}

.arco-empty-description,
.arco-result-subtitle {
  color: var(--oj-muted);
}

.arco-result-title {
  color: var(--oj-text);
}
</style>
